<div id="header">
  <p class="color-yellow font-inter size-xxl one-third">Prepare</p>
  <p class="color-red font-inter size-xxl two-third">in Stage</p>
  <p class="color-green font-inter size-xxl one-third">Make</p>
</div>
